<template lang="html">

    <div class="add-account row-start">

        <p><strong>{{$t('registro.nueva_cuenta_fiscal')}}</strong></p>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.nombre_fiscal')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="NombreFiscal"
                v-model="newaccount.NombreFiscal">
            <span class='error' v-if="clicked">{{ errors.first('NombreFiscal') }}</span>
        </div>

        <div class="contenedor-input type-text two-slot">
            <label for="">{{$t('registro.domicilio_fiscal')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="domicilioFiscal"
                v-model="newaccount.domicilioFiscal">
            <span class='error' v-if="clicked">{{ errors.first('domicilioFiscal') }}</span>
        </div>

        <div class="contenedor-input type-text quarter-slot">
            <label for="">{{$t('registro.CIF')}}*</label>
            <input type="text" v-validate="'required'" name="cifcuenta" v-model="newaccount.CIF">
            <span class='error' v-if="clicked">{{ errors.first('cifcuenta') }}</span>
        </div>

        
        <div class="contenedor-input type-text one-slot -wo-margin">
            <label for="">{{$t('registro.pais')}}</label>
            <select name="pais" v-model="newaccount.idPais" v-validate="'required'">
                <option value="">{{$t('registro.selecciona_pais')}}</option>
                <option v-if="!!dominios" v-for="(el, key) in paises" :value="Number(el[0])">{{el[1]}}</option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('pais') }}</span>
        </div>


        <div class="contenedor-input type-text one-slot" v-if="newaccount.idPais != 1">
            <label for="">{{$t('registro.provincia')}}*</label>
            <input type="text" v-validate="'required|min:3'" name="provincia" v-model="newaccount.provincia">
            <span class='error' v-if="clicked">{{ errors.first('provincia') }}</span>
        </div>


        <div class="contenedor-input type-text quarter-slot" v-if="newaccount.idPais == 1">
            <label for="">{{$t('registro.provincia')}}*</label>
            <select name="provinciaNacimiento" v-model="newaccount.idProvincia" v-validate="'required'">
                <option value="">{{$t('registro.selecciona_provincia')}}</option>
                <option :value="provincia[0]" v-for="provincia in dominiosOrder.provincias">{{provincia[1]}}</option>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('direccionUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text quarter-slot">
            <label for="">{{$t('registro.poblacion')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="poblacionUsuario"
                v-model="newaccount.poblacion">
            <span class='error' v-if="clicked">{{ errors.first('poblacionUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text quarter-slot">
            <label for="">{{$t('registro.cp')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="cpUsuario" v-model="newaccount.cp">
            <span class='error' v-if="clicked">{{ errors.first('cpUsuario') }}</span>
        </div>

        <div class="one-slot with-toggle row-start">
            <div class="contenedor-toogle">
                <toggle :show_result="false" :show="true" :label="$t('registro.requiere_envio_postal')"
                    :dataServer="newaccount.requiereEnvioPostalFacturas"
                    v-model="newaccount.requiereEnvioPostalFacturas"></toggle>
            </div>
        </div>

        <div class="contenedor-input type-text three-slot" v-if="newaccount.requiereEnvioPostalFacturas">
            <label for="">{{$t('registro.domicilio_postal')}}*</label>
            <input type="text" v-validate="'required|min:3|max:250'" name="domicilioEnvioPostal" v-model="newaccount.domicilioEnvioPostal">
            <span class='error' v-if="clicked">{{ errors.first('domicilioEnvioPostal') }}</span>
            <popup-info :texto="'envio_postal'" :side="'left'"></popup-info>
        </div>


        <div class="contenedor-botones row-start">
            <a class="btn -solid-primary" @click="validateAccount" :loading="loading">{{$t('registro.anadir_cuenta')}}</a>
            <a class="btn -skull-primary" @click="$emit('close')">{{$t('cancelar')}}</a>
        </div>


    </div>

</template>

<script lang="js">

    import Datepicker from 'vuejs-datepicker';

    import { ca, es } from 'vuejs-datepicker/dist/locale';

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import { mapGetters, mapActions } from 'vuex';

    import { Validator } from 'vee-validate';

    import toggle from '@/components/parts/form/toggle'

    import popupInfo from '@/components/parts/popup-info';

    


    export default {
        name: 'add-contacto',
        data() {
            return {
                newaccount: {
                    "idCuenta": '',
                    "NombreFiscal": "",
                    "CIF": "",
                    "requiereEnvioPostalFacturas": false,
                    "domicilioFiscal": "",
                    "idProvincia": '',
                    "Provincia": "",
                    "poblacion": "",
                    "idPais" : "",
                    "cp": "",
                    "domicilioEnvioPostal": ""
                },
                ca: ca,
                es: es,
                clicked: false,
                loading: false
            }
        },
        computed: {
            ...mapGetters({
                dominios: 'getDominios',
                dominiosOrder: 'getDominiosOrder',
                brand: 'getBrand',
                tiposContacto: 'getTipoContactoEmpresa'
            }),
        },
        methods: {
            ...mapActions(['addCuentaFiscal']),
            validateAccount() {
                this.clicked = true;
                this.$validator.validateAll()
                    .then(itsOk => {
                        if (itsOk) {
                            this.loading = true;
                            this.clicked = false;
                            this.addCuentaFiscal(this.newaccount).then(r => {
                                this.$emit('added');
                                this.loading = false;
                            });
                        }
                    });
            }
        },
        components: {
            'toggle': toggle,
            'popup-info': popupInfo,
        }
    }
</script>

<style scoped lang="scss">
    p {
        margin-left: 30px;
    }

    .form .with-toggle {
        width: 100%;
        margin-bottom: 30px;

        .contenedor-toogle {
            position: relative;
            right: auto;
            top: auto;
        }
    }

    .contenedor-botones {
        width: 100%;
        text-align: center;

        a {
            margin-right: 10px;
        }
    }

    .popup-info{
        right: 10px;
    }

    .add-account{
        margin-bottom: 30px;
    }

    @media screen and (max-width: 900px) {
        p {
            margin-left: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/documentacion/addCuentaFacturacion.vue